'use strict'

const SELECTORS = {
    element: '.js-modal-pset',
    backButtonModal: '.js-button-back-pset',
    confirmButtonModal: '.js-button-confirm-pset',
    addToCartButtonModal: '.js-button-addcart-pset',
    modalPage: '.js-modal-page',
    buttonAddToCartGlobal: '.js-button-addcart-pset .add-to-cart-global'
}

class ProductSetModal {
    constructor(element) {
        this.element = element;
        this.backButtonModal = element.find(SELECTORS.backButtonModal);
        this.confirmButtonModal = element.find(SELECTORS.confirmButtonModal);
        this.addToCartButtonModal = element.find(SELECTORS.addToCartButtonModal);
        this.buttonAddToCartGlobal = element.find(SELECTORS.buttonAddToCartGlobal);
        this.pages = element.find(SELECTORS.modalPage)
        this.initEvents();
    }

    initEvents() {
        this.pages.hide();
        this.pages.eq(0).show();
        let page_track = 0;
        this.backButtonModal.attr("style","display: none;");
        this.addToCartButtonModal.attr("style","display: none;");
        this.confirmButtonModal.on('click', (e) => {
            if (this.checkSelections(page_track, this.pages)) {
                $(this).trigger('blur');

                if(page_track == 0) {
                    this.backButtonModal.show();
                }

                if(page_track == this.pages.length-2) {
                    this.confirmButtonModal.hide();
                    this.addToCartButtonModal.show();
                    this.buttonAddToCartGlobal.prop("disabled", false); 
                    this.updateProductSetPrice(this.pages);
                }

                if(page_track < this.pages.length-1){
                    this.updateRecapModalPage(page_track, this.pages);
                    page_track++;
                    this.pages.hide();
                    this.pages.eq(page_track).show();
                }
            }      
        });

        this.backButtonModal.on('click', (e) => {
            if(page_track == 1) {
                this.backButtonModal.hide();
            }

            if(page_track == this.pages.length-1) {
                this.confirmButtonModal.show();
                this.addToCartButtonModal.hide();
            }

            if(page_track > 0) {
                page_track--;

                this.pages.hide();
                this.pages.eq(page_track).show();
            }
        });

        var $this = this;

        $('body').on('product:afterAddToCart', function () {
            $this.closeModal();
        });
        $('body').on('product:afterAttributeSelect', function (e, response) {
            $this.updateProductVariationImage(e, response);
        });
        
    }
    
    checkSelections(page_track, pages) {
        var page = pages.eq(page_track);
        var size_variations = page.find('.size-value');
        var color_variations = page.find('.color-value');

        var size_var_selected = false;
        for (var i = 0; i < size_variations.length; i++) {
            if (size_variations[i].classList.contains('selected')) {
                size_var_selected = true;
            }
        }
        
        var color_var_selected = false;
        for (var i = 0; i < color_variations.length; i++) {
            if (color_variations[i].classList.contains('selected')) {
                color_var_selected = true;
            }
        }

        return size_var_selected && color_var_selected;
    }

    updateRecapModalPage(page_track, pages) {
        var recap_page_index = pages.length - 1;
        var page = pages.eq(page_track);
        var recapPage = pages.eq(recap_page_index);

        var color_variation = page.find('.color-value.selected').closest('.color-attribute');
        var color_variation_imgUrl = color_variation.attr('data-image');
        var size_variation_text = page.find('.size-value.selected').attr('data-attr-value');

        recapPage.find('.color-image-recap-index-' + page_track).attr('src', color_variation_imgUrl);
        recapPage.find('.size-recap-index-' + page_track).text(size_variation_text);
    }

    updateProductSetPrice(pages) {
        var updatePsPriceURL = $('.recap-page').attr('data-ps-price-update-url');
        var recap_page_index = pages.length - 1;
        var pSetIds = [];
        for (var i=0; i<pages.length-1; i++) {
            var currentPage = pages.eq(i);
            var currentProductId = currentPage.find('.product-id').text();
            pSetIds.push(currentProductId);
        }

        var pSetIdsStr = JSON.stringify(pSetIds);

        var form = {
            pSetIds: pSetIdsStr,
        }; 

        $.ajax({
            url: updatePsPriceURL,
            method: 'GET',
            data: form,
            success: function (data) {
                if(data.psPriceHtml) {
                    var recap_page = pages.eq(recap_page_index);
                    recap_page.find('.cc-product__price').replaceWith(data.psPriceHtml);
                }
            },
            error: function () {}
        });
    }

    // Update primary images
    updateProductVariationImage(e, response) {
        var primaryImage = response.data.product.images.large.length > 0 ? response.data.product.images.large[0] : null;
        if (primaryImage && primaryImage.url) {
            response.container.find('#modal-product-image').attr('src', primaryImage.url);
        }
    }

    closeModal() {
       this.element.modal('hide');
    }
}


module.exports = () => {
    $(SELECTORS.element).each((index, element) => {
        new ProductSetModal($(element));
    });
};